module.exports = __webpack_public_path__ + "img/insta.478e2df7.svg";